import React, { useMemo, useCallback } from 'react';
import { join, filter, pipe, props } from 'ramda';
import PropTypes from 'prop-types';

import { NAME, ZIP_CODE, ADDRESS, CITY, CANTON, SERVICES, YAG_LASER, BIOMETRY } from 'store/organizations';

import { ReactComponent as CrossIcon } from 'assets/svg-icons/cross.svg';
import { Container, Wrapper, Text, Box, Label, Button } from './styles';

const OrganizationItem = ({ item, onDelete, disabled }) => {
  const [name, address, other, services] = useMemo(
    () => [
      item[NAME],
      item[ADDRESS],
      pipe(props([ZIP_CODE, CITY, CANTON]), filter(Boolean), join(' '))(item),
      [item[SERVICES]?.[YAG_LASER] && 'YAG-Laser', item[SERVICES]?.[BIOMETRY] && 'Biometrie'].filter(Boolean),
    ],
    [item]
  );
  const handleDelete = useCallback(() => onDelete(item), [onDelete, item]);

  return (
    <Container>
      <Wrapper>
        {Boolean(name) && <Text>{name}</Text>}
        {Boolean(address) && <Text>{address}</Text>}
        {Boolean(other) && <Text>{other}</Text>}
        {Boolean(services.length) && (
          <Box>
            {services.map((service) => (
              <Label key={service}>{service}</Label>
            ))}
          </Box>
        )}
      </Wrapper>
      {!disabled && (
        <Button type="button" onClick={handleDelete}>
          <CrossIcon />
        </Button>
      )}
    </Container>
  );
};

OrganizationItem.defaultProps = { disabled: false };
OrganizationItem.propTypes = {
  item: PropTypes.shape({
    [NAME]: PropTypes.string,
    [ADDRESS]: PropTypes.string,
    [ZIP_CODE]: PropTypes.string,
    [CITY]: PropTypes.string,
    [CANTON]: PropTypes.string,
    [SERVICES]: PropTypes.shape({
      [YAG_LASER]: PropTypes.bool,
      [BIOMETRY]: PropTypes.bool,
    }),
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default OrganizationItem;
